import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div style={{ background: '#000', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '80px 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 64 }}>
          <h1 style={{ fontSize: 42, fontWeight: 700, marginBottom: 16 }}>About <span style={{ color: '#00d55b' }}>MS Discoveries</span></h1>
          <p style={{ color: '#888', fontSize: 18, lineHeight: 1.7 }}>A technology-driven company focused on creating innovative digital solutions for modern businesses.</p>
        </div>
        {[
          { title: 'Who We Are', content: 'MS Discoveries is a technology-driven company focused on creating innovative digital solutions for modern businesses. We specialize in developing tools that improve communication, automation, and online business operations. Our solutions help companies enhance their customer interaction while improving efficiency and productivity.' },
          { title: 'Our Experience', content: 'With strong expertise in web development, digital tools, and AI-powered solutions, we develop products that help businesses stay ahead in the digital world. Our team brings years of hands-on experience building scalable, reliable, and user-friendly platforms.' },
          { title: 'Our Mission', content: 'Our mission is to empower businesses with smart technologies that simplify communication and improve customer engagement. We believe every business, regardless of size, deserves access to powerful tools that were once available only to large enterprises.' },
          { title: 'Our Vision', content: 'Our vision is to become a trusted global provider of intelligent digital solutions that transform how businesses interact with customers. We are committed to continuous innovation and building products that make a real difference.' }
        ].map(s => (
          <div key={s.title} style={{ marginBottom: 48 }}>
            <h2 style={{ fontSize: 24, fontWeight: 700, color: '#00d55b', marginBottom: 16 }}>{s.title}</h2>
            <p style={{ color: '#888', fontSize: 16, lineHeight: 1.8 }}>{s.content}</p>
          </div>
        ))}
        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 16, padding: 32, marginBottom: 48 }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24 }}>What We Do</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
            {['AI Chatbot Development', 'Business Automation Tools', 'Website Integration Solutions', 'Customer Support Technologies'].map(item => (
              <div key={item} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ color: '#00d55b' }}>✓</span>
                <span style={{ color: '#888', fontSize: 14 }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Link to="/contact" style={{ display: 'inline-block', padding: '14px 40px', background: '#00d55b', color: '#000', borderRadius: 10, fontSize: 16, fontWeight: 700 }}>Get in Touch →</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
